import { Text } from 'ui';
import type { MessageDirection } from '../../../types';
import { ChatMessageBubbleTextWithLinks } from './chat-message-bubble-text-with-links';

type P = {
  direction: MessageDirection;
  text: string;
};

const ChatMessageBubbleText = ({ direction, text }: P) => (
  <Text size="medium" type={direction === 'incoming' ? undefined : 'light'}>
    <ChatMessageBubbleTextWithLinks direction={direction} text={text} />
  </Text>
);

export default ChatMessageBubbleText;
